<template>
  <div ref="editorDiv" contenteditable="true" @input="update"></div>
  
</template>

<script>
export default {
  name: "editable",
  props: {
    value: { type: String, default: "" },
    maxlength: { type: Number, default: 10 },
    enterToEditEnd: { type: Boolean, default: false }
  },
  data() {
    return {
      IsFocus: false,
      IsShowRemoveInput: false,
      canMessageSubmit: false,
    };
  },
 
  mounted() {
    this.$el.innerText = this.value;
  },
  methods: {
    update: function(event) {

      //   var len = event.target.innerText.length
      
      // if(len > this.maxlength)
      // {
      //     event.target.innerText = event.target.innerText.substring(0,this.maxlength);
      //     return;
      // }

      // inputイベントによってv-modelが更新され、するとバインドされているthis.valueも更新される。
      this.$emit('input', event.target.innerText) 
      //this.value = event.target.innerText;
      //this.$emit("update", event.target.innerText);
    },
    ToFocus(){

      this.$nextTick(() => {
        this.placeCaretAtEnd(this.$refs.editorDiv)
      })
      

    },
    //Editableの最後の文字の後ろにキャレットをあてる
    placeCaretAtEnd(el) {
      el.focus();
      if (typeof window.getSelection != "undefined"
              && typeof document.createRange != "undefined") {
          var range = document.createRange();
          range.selectNodeContents(el);
          range.collapse(false);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
      } else if (typeof document.body.createTextRange != "undefined") {
          var textRange = document.body.createTextRange();
          textRange.moveToElementText(el);
          textRange.collapse(false);
          textRange.select();
      }
  }

  }
};
</script>

<style scoped lang="scss">
//===========================
//読み取り専用スタイル
//===========================
.readonly {
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Editable.vue